var _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon2 = function SvgIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 125,
    viewBox: "0 0 128 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 59,
    fill: "black",
    stroke: "#E7F58D",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.8402 69.2352L91.0022 65.0831C98.1637 57.9251 94.6204 48.2308 88.8462 42.0122C86.9527 39.9643 84.7779 38.1795 82.5282 36.9208C79.6036 35.2675 70.4173 32.8627 64.3993 38.7244L51.9321 51.1616C48.5575 54.5246 57.069 57.7748 61.3622 53.5289L64.5118 50.4289C69.1612 46.2018 74.9917 54.6561 82.247 48.9071",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3016 67.261L34.1584 63.109C20.3226 49.2814 44.2821 25.5341 58.3053 39.2113L61.0987 41.9919",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1299 53.4346L87.1966 70.3057C90.4774 73.7438 85.603 80.3006 81.4036 75.9607L73.867 68.1827",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3047 73.4257L75.5724 81.9364C78.8907 85.3557 85.5836 80.3019 81.3841 75.962L73.3039 67.6016",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.793 82.8371L68.9174 87.0079C72.2545 90.3897 78.7599 85.5613 74.5792 81.165",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1449 63.8411L48.5949 64.292C50.0947 65.795 50.0759 68.2374 48.5949 69.7404L42.8768 75.4705C41.3958 76.9547 38.9398 76.9735 37.44 75.4705L36.9901 75.0196C35.4903 73.5166 35.4903 71.0743 36.9901 69.5713L42.7081 63.8411C44.2079 62.3381 46.6451 62.3381 48.1449 63.8411ZM57.7812 66.4714L58.2311 66.9223C59.731 68.4252 59.7122 70.8676 58.2311 72.3706L49.1198 81.5013C47.6387 82.9855 45.1828 82.9855 43.683 81.5013L43.233 81.0504C41.752 79.5662 41.7332 77.105 43.233 75.6021L52.3444 66.4714C53.8442 64.9684 56.2814 64.9684 57.7812 66.4714ZM61.4932 75.0009L61.9432 75.4518C63.443 76.9547 63.443 79.3971 61.9432 80.9001L55.7002 87.1563C54.2004 88.6593 51.7632 88.6593 50.2634 87.1563L49.8135 86.7054C48.3137 85.2024 48.3137 82.7601 49.8135 81.2571L56.0564 75.0009C57.5562 73.4979 59.9934 73.4979 61.4932 75.0009ZM65.5052 83.1358L65.9552 83.5867C67.455 85.0897 67.4362 87.5321 65.9552 89.0351L62.1119 92.8865C60.6308 94.3707 58.1749 94.3707 56.6751 92.8865L56.2252 92.4356C54.7441 90.9514 54.7253 88.4902 56.2252 86.9872L60.0684 83.1358C61.5682 81.6328 64.0054 81.6328 65.5052 83.1358Z",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeMiterlimit: 22.93
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 62,
    r: 60,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeDasharray: "5 5"
  })));
};
export default SvgIcon2;